import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useCollapseStore = defineStore('collapse', () => {
    const isCollapse = ref(false);

    function toggleCollapse() {
        isCollapse.value = !isCollapse.value;
    }

    return { isCollapse, toggleCollapse };
});
